export default "__VITE_ASSET__BEPUgvLO__"